// extracted by mini-css-extract-plugin
export default {"markdown-content":"markdown-content--EnuP8","anchor":"anchor--zN5JV"};